import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import ReadMoreAndLess from 'react-read-more-less';
import geofertImg from '../../../../assets/images/001-agriculture.svg';
import sprayDroneImg from '../../../../assets/images/002-drone.svg';
import smartFarmImg from '../../../../assets/images/003-smart-farm.svg';
import satelliteImg from '../../../../assets/images/004-satellite.svg';
import vantImg from '../../../../assets/images/005-drone-1.svg';
import posVendaImg from '../../../../assets/images/006-posvendas.svg';
import { getUserPermissions } from '../../../../utils/users';
import './NewService.scss';

const NewService = (props): JSX.Element => {
  const { params, nextPage } = props;
  const userPermissions = getUserPermissions();

  const getServiceImg = (id): any => {
    switch (id) {
      case 1:
        return geofertImg;

      case 2:
        return sprayDroneImg;

      case 3:
        return vantImg;

      case 4:
        return satelliteImg;

      case 5:
        return smartFarmImg;

      case 6:
        return posVendaImg;

      default:
        return geofertImg;
    }
  };

  return (
    <div className="NewService">
      <div className="cards">
        {
          params.serviceList.map(
            (v): JSX.Element | undefined => {
              if (v.idCode !== 'POS_VENDAS' || (v.idCode === 'POS_VENDAS'
                && userPermissions.includes('Solicitar novo serviço'))) {
                return (
                  <Card
                    key={v.id}
                    hoverable
                    className="service-card"
                  >
                    <a
                      onClick={
                        (): void => {
                          nextPage({ selectedService: v });
                        }
                      }
                      role="button"
                      tabIndex={0}
                      onKeyDown={
                        (eventt): void => {
                          if (eventt.key === 'Enter') {
                            nextPage({ selectedService: v });
                          }
                        }
                      }
                    >
                      <img src={getServiceImg(v.id)} alt="" />
                      <div className="card-title">{v.name}</div>
                    </a>

                    <div style={{ minHeight: 160 }}>
                      <ReadMoreAndLess
                        charLimit={120}
                        readMoreText="Leia mais"
                        readLessText="Esconder texto"
                      >
                        {v.description || ''}
                      </ReadMoreAndLess>
                    </div>
                  </Card>
                );
              }
            },
          )
        }
      </div>
    </div>
  );
};

NewService.propTypes = {
  nextPage: PropTypes.func.isRequired,

  params: PropTypes.shape({
    serviceList: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
    })),
  }).isRequired,
};

NewService.defaultProps = {};

export default NewService;
